import { createSelector } from 'reselect'

export const getAvailability = (state) => state.scheduling.availability
export const getMeta = (state) => state.scheduling.meta

export const getProviderAvailability = (providerId) =>
  createSelector(getAvailability, (availability = {}) => {
    return availability[providerId]
  })
